import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  finansiellOversiktSchema,
  driftSchema,
  kommuneoppforingSchema,
  funksjonsflaggSchema,
  administrasjonsoversiktSchema,
  importAnalyseSchema,
  importresultatSchema,
  invitasjonOpprettetSchema,
  revisjonsloggSvarSchema,
  bemanningsanalyseSchema,
  bemanningsoversiktSchema,
  bemanningsresultatSchema,
  lonnsanalyseSchema,
  lonnsforutsetningSchema,
  lonnsgrunnlagSchema,
  lonnsprognosekoblingSchema,
  lonnsoppgjorSchema,
  stillingsgruppeSchema,
  hjemmelanalyseSchema,
  hjemmelimportresultatSchema,
  hjemmelkandidatSchema,
  stillingshjemmelSchema,
  stillingsoversiktSchema,
  lonnslesingSvarSchema,
  lonnsimportresultatSchema,
  innkjopsanalyseSchema,
  innkjopsoversiktSchema,
  innkjopsresultatSchema,
  kpiVisningSchema,
  tiltakVisningSchema,
  vedtatteKuttSchema,
  posteringsvarslerSchema,
  varseloppgaverSchema,
  tiltaksdekningSchema,
  prognoseVisningSchema,
  prognoseendringerSchema,
  prognoseleveringSchema,
  prognoseleveringerSchema,
  omradeleveringerSchema,
  treffsikkerhetSchema,
  gruppeoversiktSchema,
  gruppeSchema,
  gruppekandidaterSchema,
  moteSchema,
  aksjonspunktSchema,
  aksjonsoppgaverSchema,
  kontrolloppgaverSchema,
  prosjektfremdriftSchema,
  leveringsoppsettSchema,
  oppgaverSchema,
  okonomirapportSchema,
  rapportomfangSchema,
  rapportmalSchema,
  rapportutkastSchema,
  rapportoppgaverSchema,
  utsendelseSchema,
  rapportelementSchema,
  budsjettprosessSchema,
  budsjettforslageneSchema,
  budsjettibrukSchema,
  budsjettrevisjonerSchema,
  investeringsbudsjettSchema,
  opprettetBudsjettforslagSchema,
  harNummer,
  budsjettoppgaverSchema,
  budsjettprosesserSchema,
  detaljbudsjettSchema,
  opplastetBildeSchema,
  utsendelserSchema,
  utsendelseDetaljSchema,
  forslagSchema,
  rapportversjonSchema,
  tekstfeltSchema,
  fellesVisningSchema,
  kontoplanSchema,
  megSchema,
  virksomhetSchema,
  type FinansiellOversikt,
  type Drift,
  type Kommuneoppforing,
  type NyKommune,
  type Funksjonsflagg,
  type ImportanalyseDto,
  type ImportresultatDto,
  type Administrasjonsoversikt,
  type EndreBruker,
  type InvitasjonOpprettet,
  type InviterBruker,
  type Bemanningsanalyse,
  type BemanningsresultatDto,
  type Bemanningsoversikt,
  type Lonnsanalyse,
  type LonnsimportresultatDto,
  type LonnsforutsetningDto,
  type Lonnsgrunnlag,
  type LonnsprognosekoblingDto,
  type SettLonnsprognosekobling,
  type LonnslesingSvar,
  type LonnsoppgjorDto,
  type SettLonnsforutsetning,
  type SettLonnsoppgjor,
  type HjemmelkandidatDto,
  type SettHjemmelskobling,
  type SettStillingshjemmel,
  type StillingsgruppeDto,
  type Hjemmelanalyse,
  type HjemmelimportresultatDto,
  type StillingshjemmelDto,
  type UtforHjemmelimport,
  type Stillingsoversikt,
  type UtforBemanningsimport,
  type UtforLonnsimport,
  type ImporterInnkjop,
  type InnkjopsanalyseDto,
  type InnkjopsoversiktDto,
  type InnkjopsresultatDto,
  type KpiPeriode,
  type RevisjonsloggSvar,
  type SettTilganger,
  type KpiVisning,
  type LagreKpi,
  type LagreMaaling,
  type LagrePrognose,
  type LagreTiltak,
  type LagreVedtattKutt,
  type MeldGevinst,
  type VedtatteKutt,
  type KvitterVarsel,
  type PosteringsvarslerDto,
  type VarseloppgaverDto,
  type TreffsikkerhetDto,
  type AksjonsoppgaverDto,
  type KontrolloppgaverDto,
  type AksjonspunktDto,
  type EndreAksjonspunkt,
  type EndreGruppe,
  type GruppeDto,
  type GruppeoversiktDto,
  type Gruppekandidater,
  type LagreMote,
  type MoteDto,
  type NyGruppe,
  type NyttAksjonspunkt,
  type NyttMote,
  type SettMedlemmer,
  type LagreMilepael,
  type ProsjektfremdriftDto,
  type SettKoblinger,
  type Tiltaksdekning,
  type TiltakVisning,
  type UtforImport,
  type PrognoseVisning,
  type PrognoseendringerDto,
  type BehandleLevering,
  type LeverPrognose,
  type OmradeleveringerDto,
  type PrognoseleveringDto,
  type PrognoseleveringerDto,
  type Leveringsoppsett,
  type OppgaverDto,
  type OkonomirapportDto,
  type RapportomfangDto,
  type LagreOppsett,
  type LagreTekst,
  type OpprettRapport,
  type RapportmalDto,
  type Rapporttype,
  type RapportutkastDto,
  type RapportoppgaverDto,
  type AnkerDto,
  type EndreUtvalg,
  type OpprettUtvalg,
  type RegistrerBehandling,
  type SendTilBehandling,
  type UtsendelseDetaljDto,
  type UtsendelseDto,
  type Elementinnhold,
  type RapportelementDto,
  type Fastsett,
  type BudsjettprosessDto,
  type BudsjettoppgaverDto,
  type BudsjettprosesserDto,
  type BudsjettforslageneDto,
  type BudsjettibrukDto,
  type BudsjettrevisjonerDto,
  type NyRevisjonslinje,
  type RegistrerRevisjonsvedtak,
  type EndreInvesteringsprosjekt,
  type InvesteringsbudsjettDto,
  type NyttInvesteringsprosjekt,
  type TaIBruk,
  type EndreBudsjettforslag,
  type NyForslagslinje,
  type NyttBudsjettforslag,
  type OpprettetBudsjettforslag,
  type RegistrerVedtak,
  type DetaljbudsjettDto,
  type SettBudsjettfordeling,
  type SettDetaljrad,
  type EndreBudsjett,
  type EndreBudsjetttiltak,
  type NyBudsjettendring,
  type NyttBudsjetttiltak,
  type Tiltaksstatus,
  type UtsendelserDto,
  type ForslagDto,
  type NyttForslag,
  type RapportversjonDto,
  type TekstfeltDto,
  type FellesVisningDto,
  type OversiktsoppsettDto,
  type Kontoplan,
  type Meg,
  type Virksomhet,
  identitetsleverandorSchema,
  type EndreIdentitetsleverandor,
  type IdentitetsleverandorDto,
  type OpprettIdentitetsleverandor,
  type EndreKommunalomrade,
  type EndreVirksomhet,
  type OpprettKommunalomrade,
  type OpprettVirksomhet,
  omradeoversiktSchema,
  type Omradeoversikt,
  integrasjonSchema,
  integrasjonsoppsettSchema,
  dimensjonskoblingSchema,
  type Dimensjonskobling,
  type NyDimensjonskobling,
  type Hemmeligheter,
  type Integrasjon,
  type Integrasjonsoppsett,
  type NyIntegrasjon,
  investeringsoppfolgingSchema,
  portefoljeSchema,
  type PortefoljeDto,
  type LagreProsjektinfo,
  investeringsoppgaverSchema,
  investeringsimportAnalyseSchema,
  investeringsimportresultatSchema,
  type InvesteringsoppfolgingDto,
  type InvesteringsoppgaverDto,
  type InvesteringsimportAnalyseDto,
  type InvesteringsimportresultatDto,
  type MeldInvesteringsprognose,
  type EndreInvestering,
  type UtforInvesteringsimport,
  type Valutaenhet,
  type Budsjettkilde,
} from '@es/shared';
import { z } from 'zod';
import { apiBlob, apiHent, erVersjonskonflikt } from './klient.js';
import { rapportsti, type Rapportvalg } from '../sider/rapportering/rapportvalg.js';

/**
 * Server state via TanStack Query (§1) — no hand-rolled cache invalidation.
 *
 * Query keys are namespaced so that a future mutation can invalidate exactly
 * what it changed, rather than everything.
 */
export const nokler = {
  meg: ['meg'] as const,
  virksomheter: ['virksomheter'] as const,
  kontoplan: ['kontoplan'] as const,
  funksjonsflagg: ['funksjonsflagg'] as const,
  drift: ['drift'] as const,
  kommuner: ['kommuner'] as const,
  kommunemoduler: (kommuneId: string) => ['kommuner', kommuneId, 'moduler'] as const,
  integrasjoner: ['integrasjoner'] as const,
  dimensjoner: ['dimensjoner'] as const,
  integrasjonsoppsett: ['integrasjoner', 'oppsett'] as const,
  finansiellOversikt: (virksomhetId: string, ar: number) =>
    ['finansiell-oversikt', virksomhetId, ar] as const,
  prognose: (virksomhetId: string, ar: number) => ['prognose', virksomhetId, ar] as const,
  prognoseendringer: (virksomhetId: string, ar: number) =>
    ['prognoseendringer', virksomhetId, ar] as const,
  fellesVisning: (type: string, id: string) => ['felles-visning', type, id] as const,
  prognoseleveringer: (virksomhetId: string, ar: number) =>
    ['prognoseleveringer', 'virksomhet', virksomhetId, ar] as const,
  omradeleveringer: (omradeId: string, ar: number) =>
    ['prognoseleveringer', 'omrade', omradeId, ar] as const,
  /** Alle leveringer, for virksomheter og områder: en behandling endrer begge. */
  alleLeveringer: ['prognoseleveringer'] as const,
  leveringsoppsett: ['administrasjon', 'leveringsoppsett'] as const,
  /** Under leveringene, så alt som endrer en levering også henter oppgavene på nytt. */
  oppgaver: ['prognoseleveringer', 'oppgaver'] as const,
  rapportomfang: ['rapportering', 'omfang'] as const,
  okonomirapport: (sti: string) => ['rapportering', 'okonomi', sti] as const,
  rapportmal: (type: string) => ['rapportering', 'mal', type] as const,
  /** Alle rapportene: oppsett, tekst og fastsetting endrer det som vises. */
  rapporter: ['rapportering', 'rapport'] as const,
  /** Under rapportene: hver endring i en rapport kan endre oppgavene. */
  rapportoppgaver: ['rapportering', 'rapport', 'oppgaver'] as const,
  /** Den politiske behandlingen: listen, og hver utsendelse under. */
  behandling: ['rapportering', 'behandling'] as const,
  utsendelser: (rapportId: string | null) =>
    ['rapportering', 'behandling', 'liste', rapportId ?? 'alle'] as const,
  utsendelse: (id: string) => ['rapportering', 'behandling', 'en', id] as const,
  rapport: (ar: number, type: string, nummer: number | null) =>
    ['rapportering', 'rapport', ar, type, nummer] as const,
  rapportversjon: (rapportId: string, versjon: number) =>
    ['rapportering', 'versjon', rapportId, versjon] as const,
  bemanning: (virksomhetId: string, ar: number) => ['bemanning', virksomhetId, ar] as const,
  innkjop: (virksomhetId: string, ar: number) => ['innkjop', virksomhetId, ar] as const,
  kpi: (virksomhetId: string, ar: number, periode: KpiPeriode, maned: number | null) =>
    ['kpi', virksomhetId, ar, periode, maned] as const,
  tiltak: (virksomhetId: string, ar: number) => ['tiltak', virksomhetId, ar] as const,
  vedtatteKutt: (ar: number) => ['vedtatte-kutt', ar] as const,
  tiltaksdekning: (ar: number) => ['tiltaksdekning', ar] as const,
  posteringsvarsler: (virksomhetId: string, ar: number) =>
    ['posteringsvarsler', virksomhetId, ar] as const,
  varseloppgaver: ['varseloppgaver'] as const,
  grupper: ['grupper'] as const,
  gruppe: (id: string) => ['grupper', id] as const,
  gruppekandidater: ['gruppekandidater'] as const,
  mote: (gruppeId: string, moteId: string) => ['grupper', gruppeId, 'mote', moteId] as const,
  aksjonsoppgaver: ['aksjonsoppgaver'] as const,
  kontrolloppgaver: ['kontrolloppgaver'] as const,
  fremdrift: (gruppeId: string) => ['grupper', gruppeId, 'fremdrift'] as const,
  investeringer: (ar: number) => ['investeringer', ar] as const,
  investeringsoppgaver: ['investeringsoppgaver'] as const,
  portefolje: ['portefolje'] as const,
  treffsikkerhet: (omfang: string, id: string, ar: number) =>
    ['treffsikkerhet', omfang, id, ar] as const,
  omradeoversikt: (omradeId: string, ar: number) => ['omradeoversikt', omradeId, ar] as const,
  /** Alle områdeoversikter, uansett område og år. */
  alleOmradeoversikter: ['omradeoversikt'] as const,
  administrasjon: ['administrasjon'] as const,
  revisjonslogg: (side: number, handling: string) =>
    ['administrasjon', 'revisjonslogg', side, handling] as const,
  stillingsoversikt: (virksomhetId: string, ar: number) =>
    ['bemanning', virksomhetId, 'stillinger', ar] as const,
  prognosekobling: (virksomhetId: string, ar: number) =>
    ['bemanning', virksomhetId, 'prognosekobling', ar] as const,
  lonnsgrunnlag: (virksomhetId: string, ar: number) =>
    ['bemanning', virksomhetId, 'lonnsgrunnlag', ar] as const,
  lonnslesing: (side: number, ansattId: string) =>
    ['administrasjon', 'lonnslesing', side, ansattId] as const,
};

export function useMeg(): UseQueryResult<Meg> {
  return useQuery({
    queryKey: nokler.meg,
    queryFn: () => apiHent('/meg', megSchema),
    // Identity and role assignments change rarely within a session.
    staleTime: 5 * 60 * 1000,
  });
}

export function useVirksomheter(): UseQueryResult<Virksomhet[]> {
  return useQuery({
    queryKey: nokler.virksomheter,
    queryFn: () => apiHent('/virksomheter', z.array(virksomhetSchema)),
    staleTime: 5 * 60 * 1000,
  });
}

export function useKontoplan(): UseQueryResult<Kontoplan> {
  return useQuery({
    queryKey: nokler.kontoplan,
    queryFn: () => apiHent('/kontoplan', kontoplanSchema),
    // The kontoplan is shared per kommune and changes only at onboarding or
    // when an import introduces a new account.
    staleTime: 30 * 60 * 1000,
  });
}

export interface SettKommunemodul {
  readonly kommuneId: string;
  readonly nokkel: string;
  readonly aktivert: boolean;
}

/** Modulene for én kommune. Bare for leverandøren; se `KommunerController`. */
export function useKommunemoduler(kommuneId: string): UseQueryResult<Funksjonsflagg[]> {
  return useQuery({
    queryKey: nokler.kommunemoduler(kommuneId),
    queryFn: () => apiHent(`/kommuner/${kommuneId}/moduler`, z.array(funksjonsflaggSchema)),
  });
}

/**
 * Slår en modul av eller på for én kommune.
 *
 * Kommunens egne brukere kan ikke det — det er leverandørens avgjørelse, per
 * kommune. Gjelder det leverandørens egen kommune, endres også menyen her.
 */
export function useSettKommunemodul(): UseMutationResult<
  Funksjonsflagg,
  unknown,
  SettKommunemodul
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ kommuneId, nokkel, aktivert }) =>
      apiHent(`/kommuner/${kommuneId}/moduler/${nokkel}`, funksjonsflaggSchema, {
        method: 'PUT',
        body: JSON.stringify({ aktivert }),
      }),
    onSuccess: (_svar, { kommuneId }) => {
      void koe.invalidateQueries({ queryKey: nokler.kommunemoduler(kommuneId) });
      // Flaggene styrer menyen og rutene. Billig å hente, og riktig hvis det
      // var leverandørens egen kommune som ble endret.
      void koe.invalidateQueries({ queryKey: nokler.funksjonsflagg });
    },
  });
}

export function useFunksjonsflagg(): UseQueryResult<Funksjonsflagg[]> {
  return useQuery({
    queryKey: nokler.funksjonsflagg,
    queryFn: () => apiHent('/funksjonsflagg', z.array(funksjonsflaggSchema)),
    staleTime: 60 * 1000,
  });
}

/**
 * Hva serveren har igjen å gå på. Bare plattformadmin får svar.
 *
 * `staleTime` er lav og den friskes opp i bakgrunnen: dette er det ene tallet
 * der en gammel verdi er verre enn ingen. En disk som fylles gjør det ikke
 * jevnt — en utrulling tar flere gigabyte på et minutt.
 */
export function useDrift(aktivert: boolean): UseQueryResult<Drift> {
  return useQuery({
    queryKey: nokler.drift,
    queryFn: () => apiHent('/drift', driftSchema),
    enabled: aktivert,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}

/** Kommunene på plattformen. Bare leverandøren får svar. */
export function useKommuner(aktivert: boolean): UseQueryResult<Kommuneoppforing[]> {
  return useQuery({
    queryKey: nokler.kommuner,
    queryFn: () => apiHent('/kommuner', z.array(kommuneoppforingSchema)),
    enabled: aktivert,
    staleTime: 60 * 1000,
  });
}

export function useOpprettKommune(): UseMutationResult<Kommuneoppforing, unknown, NyKommune> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: NyKommune) =>
      apiHent('/kommuner', kommuneoppforingSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.kommuner });
    },
  });
}

export function useFinansiellOversikt(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<FinansiellOversikt> {
  return useQuery({
    queryKey: nokler.finansiellOversikt(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/finansiell-oversikt?ar=${ar}`,
        finansiellOversiktSchema,
      ),
    // Nothing to fetch until a virksomhet has been chosen; without this the hook
    // would fire a request to `/virksomheter//finansiell-oversikt` on first render.
    enabled: virksomhetId !== undefined,
    // Short: an import can land new actuals at any time, and a finance officer
    // refreshing after an import should see them.
    staleTime: 30 * 1000,
  });
}

export function usePrognose(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<PrognoseVisning> {
  return useQuery({
    queryKey: nokler.prognose(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/prognose?ar=${ar}`, prognoseVisningSchema),
    enabled: virksomhetId !== undefined,
    // Never refetched WHILE the screen is open: the user holds unsaved edits, and
    // swapping the basis under their fingers would be worse than slightly stale
    // data. But ALWAYS refetched on mount, because the forecast changes
    // underneath this page — an import books actuals, which lock months that were
    // editable a moment ago. `refetchOnMount: false` here meant that after an
    // import the page showed the pre-import state, with booked months still
    // presented as editable.
    staleTime: Infinity,
    refetchOnMount: 'always',
  });
}

/** Årets leveringer av prognosen, og perioden som kan leveres nå. */
export function usePrognoseleveringer(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<PrognoseleveringerDto> {
  return useQuery({
    queryKey: nokler.prognoseleveringer(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/prognose/leveringer?ar=${String(ar)}`,
        prognoseleveringerSchema,
      ),
    enabled: virksomhetId !== undefined,
  });
}

/** Kommunalsjefens oversikt: leveringene for hver virksomhet i området. */
export function useOmradeleveringer(
  omradeId: string | undefined,
  ar: number,
): UseQueryResult<OmradeleveringerDto> {
  return useQuery({
    queryKey: nokler.omradeleveringer(omradeId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/kommunalomrader/${omradeId ?? ''}/prognose/leveringer?ar=${String(ar)}`,
        omradeleveringerSchema,
      ),
    enabled: omradeId !== undefined,
  });
}

export function useLeverPrognose(): UseMutationResult<
  PrognoseleveringerDto,
  unknown,
  { virksomhetId: string } & LeverPrognose
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ virksomhetId, ...data }) =>
      apiHent(`/virksomheter/${virksomhetId}/prognose/leveringer`, prognoseleveringerSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.prognoseleveringer(svar.virksomhetId, svar.ar), svar);
      void koe.invalidateQueries({ queryKey: ['prognoseleveringer', 'omrade'] });
      void koe.invalidateQueries({ queryKey: nokler.oppgaver });
    },
  });
}

const leveringsadresse = (virksomhetId: string, leveringId: string): string =>
  `/virksomheter/${virksomhetId}/prognose/leveringer/${leveringId}`;

/** Godkjenner, eller sender tilbake. Bare kommunalsjefen; serveren avgjør. */
export function useBehandleLevering(): UseMutationResult<
  PrognoseleveringDto,
  unknown,
  { virksomhetId: string; leveringId: string } & BehandleLevering
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ virksomhetId, leveringId, ...data }) =>
      apiHent(`${leveringsadresse(virksomhetId, leveringId)}/behandling`, prognoseleveringSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    // Uansett utfall: er den behandlet av en annen i mellomtiden, skal skjermen
    // vise det, ikke det den trodde.
    onSettled: () => koe.invalidateQueries({ queryKey: nokler.alleLeveringer }),
  });
}

export function useKommenterLevering(): UseMutationResult<
  PrognoseleveringDto,
  unknown,
  { virksomhetId: string; leveringId: string; tekst: string }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ virksomhetId, leveringId, tekst }) =>
      apiHent(`${leveringsadresse(virksomhetId, leveringId)}/kommentarer`, prognoseleveringSchema, {
        method: 'POST',
        body: JSON.stringify({ tekst }),
      }),
    onSuccess: () => koe.invalidateQueries({ queryKey: nokler.alleLeveringer }),
  });
}

/** Områdene kalleren kan ta ut rapport for, og om hele kommunen. */
export function useRapportomfang(): UseQueryResult<RapportomfangDto> {
  return useQuery({
    queryKey: nokler.rapportomfang,
    queryFn: () => apiHent('/rapportering/omfang', rapportomfangSchema),
  });
}

/**
 * Økonomirapporten for valget. Hentes på nytt hver gang siden åpnes: den bygger
 * på leveringene slik de står, og en godkjenning siden sist skal med.
 */
export function useOkonomirapport(
  valg: Rapportvalg | undefined,
): UseQueryResult<OkonomirapportDto> {
  const sti = valg === undefined ? '' : rapportsti(valg);
  return useQuery({
    queryKey: nokler.okonomirapport(sti),
    queryFn: () => apiHent(sti, okonomirapportSchema),
    enabled: valg !== undefined,
    refetchOnMount: 'always',
  });
}

/** Malen for rapporttypen. Bare for økonomisjefen. */
export function useRapportmal(type: Rapporttype): UseQueryResult<RapportmalDto> {
  return useQuery({
    queryKey: nokler.rapportmal(type),
    queryFn: () => apiHent(`/rapportering/maler/${type}`, rapportmalSchema),
  });
}

export function useLagreRapportmal(): UseMutationResult<
  RapportmalDto,
  unknown,
  { type: Rapporttype } & LagreOppsett
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ type, ...data }) =>
      apiHent(`/rapportering/maler/${type}`, rapportmalSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.rapportmal(svar.type), svar);
    },
  });
}

const rapportsporring = (ar: number, type: Rapporttype, nummer: number | null): string => {
  const s = new URLSearchParams({ ar: String(ar), type });
  if (harNummer(type) && nummer !== null) s.set('nummer', String(nummer));
  return s.toString();
};

/** Rapporten for perioden, slik kalleren ser den. Null før den er opprettet. */
export function useRapportutkast(
  ar: number,
  type: Rapporttype,
  nummer: number | null,
): UseQueryResult<RapportutkastDto> {
  return useQuery({
    queryKey: nokler.rapport(ar, type, nummer),
    queryFn: () =>
      apiHent(`/rapportering/rapporter?${rapportsporring(ar, type, nummer)}`, rapportutkastSchema),
    refetchOnMount: 'always',
  });
}

export function useOpprettRapport(): UseMutationResult<RapportutkastDto, unknown, OpprettRapport> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent('/rapportering/rapporter', rapportutkastSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar, data) => {
      koe.setQueryData(nokler.rapport(data.ar, data.type, data.nummer), svar);
    },
  });
}

/** Etter en endring i rapporten: hent den på nytt, slik serveren nå ser den. */
const hentRapporterPaNytt = (koe: ReturnType<typeof useQueryClient>) =>
  koe.invalidateQueries({ queryKey: nokler.rapporter });

export function useLagreRapportoppsett(): UseMutationResult<
  void,
  unknown,
  { rapportId: string } & LagreOppsett
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, ...data }) => {
      await apiHent(`/rapportering/rapporter/${rapportId}/oppsett`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

export function useLagreRapporttekst(): UseMutationResult<
  TekstfeltDto,
  unknown,
  { rapportId: string } & LagreTekst
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/tekst`, tekstfeltSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => hentRapporterPaNytt(koe),
  });
}

/** Fastsetter rapporten — og sender den nye versjonen til politisk behandling, om ønsket. */
export function useFastsettRapport(): UseMutationResult<
  RapportversjonDto,
  unknown,
  { rapportId: string } & Fastsett
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/fastsett`, rapportversjonSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () =>
      Promise.all([
        hentRapporterPaNytt(koe),
        koe.invalidateQueries({ queryKey: ['rapportering', 'behandling'] }),
      ]),
  });
}

/** Fristen for innspill til rapporten. Bare den som styrer; serveren avgjør. */
export function useSettRapportfrist(): UseMutationResult<
  void,
  unknown,
  { rapportId: string; frist: string | null }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, frist }) => {
      await apiHent(`/rapportering/rapporter/${rapportId}/frist`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify({ frist }),
      });
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

/** Marker et område som ferdig skrevet, eller åpne det igjen. */
export function useMarkerOmradeFerdig(): UseMutationResult<
  void,
  unknown,
  { rapportId: string; omradeId: string; ferdig: boolean }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, omradeId, ferdig }) => {
      await apiHent(
        `/rapportering/rapporter/${rapportId}/omrader/${omradeId}/ferdig`,
        z.unknown(),
        {
          method: 'PUT',
          body: JSON.stringify({ ferdig }),
        },
      );
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

/** Avdelingslederens forslag til tekst i kommunalområdets kapittel. */
export function useNyttForslag(): UseMutationResult<
  ForslagDto,
  unknown,
  { rapportId: string } & NyttForslag
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/forslag`, forslagSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => hentRapporterPaNytt(koe),
  });
}

/** Den som skriver kapitlet, bruker forslaget eller avviser det. */
export function useBehandleForslag(): UseMutationResult<
  void,
  unknown,
  { rapportId: string; forslagId: string; status: 'brukt' | 'avvist' }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, forslagId, status }) => {
      await apiHent(`/rapportering/rapporter/${rapportId}/forslag/${forslagId}`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify({ status }),
      });
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

/**
 * Det som venter på kalleren i rapportene: skrive, følge opp, foreslå.
 * `aktiv` er om rapporteringsmodulen er på.
 */
export function useRapportoppgaver(aktiv: boolean): UseQueryResult<RapportoppgaverDto> {
  return useQuery({
    queryKey: nokler.rapportoppgaver,
    queryFn: () => apiHent('/rapportering/oppgaver', rapportoppgaverSchema),
    enabled: aktiv,
  });
}

// --- Budsjett og økonomiplan ------------------------------------------------------

const budsjettnokler = {
  alle: ['budsjett'] as const,
  prosesser: ['budsjett', 'prosesser'] as const,
  oppgaver: ['budsjett', 'oppgaver'] as const,
  ar: (ar: number) => ['budsjett', 'ar', ar] as const,
  detalj: (ar: number, virksomhetId: string) => ['budsjett', 'detalj', ar, virksomhetId] as const,
  forslag: (ar: number) => ['budsjett', 'forslag', ar] as const,
  iBruk: (ar: number) => ['budsjett', 'i-bruk', ar] as const,
  investering: (ar: number) => ['budsjett', 'investering', ar] as const,
  revisjoner: (ar: number) => ['budsjett', 'revisjoner', ar] as const,
};

/** Etter en endring i budsjettet: hent det på nytt, slik serveren nå ser det. */
const hentBudsjettPaNytt = (koe: ReturnType<typeof useQueryClient>) =>
  koe.invalidateQueries({ queryKey: budsjettnokler.alle });

/** Det som venter på kalleren i budsjettet. Under `budsjett`, så hver endring henter dem på nytt. */
export function useBudsjettoppgaver(aktiv: boolean): UseQueryResult<BudsjettoppgaverDto> {
  return useQuery({
    queryKey: budsjettnokler.oppgaver,
    queryFn: () => apiHent('/budsjett/oppgaver', budsjettoppgaverSchema),
    enabled: aktiv,
  });
}

export function useBudsjettprosesser(): UseQueryResult<BudsjettprosesserDto> {
  return useQuery({
    queryKey: budsjettnokler.prosesser,
    queryFn: () => apiHent('/budsjett', budsjettprosesserSchema),
  });
}

/** Budsjettet for året, slik kalleren ser det. Prosessen er null før det er opprettet. */
export function useBudsjett(ar: number): UseQueryResult<BudsjettprosessDto> {
  return useQuery({
    queryKey: budsjettnokler.ar(ar),
    queryFn: () => apiHent(`/budsjett/${String(ar)}`, budsjettprosessSchema),
  });
}

export function useOpprettBudsjett(): UseMutationResult<BudsjettprosessDto, unknown, number> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (ar) =>
      apiHent('/budsjett', budsjettprosessSchema, {
        method: 'POST',
        body: JSON.stringify({ ar }),
      }),
    onSuccess: () => hentBudsjettPaNytt(koe),
  });
}

/** En skriveoperasjon i budsjettet for et år, som ikke gir noe tilbake. */
function useBudsjettskriving<T>(
  sti: (ar: number, data: T) => string,
  metode: 'POST' | 'PUT' | 'DELETE',
  kropp: (data: T) => unknown = (data) => data,
): UseMutationResult<void, unknown, { ar: number; data: T }> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ ar, data }) => {
      await apiHent(sti(ar, data), z.unknown(), {
        method: metode,
        ...(metode === 'DELETE' ? {} : { body: JSON.stringify(kropp(data)) }),
      });
    },
    onSettled: () => hentBudsjettPaNytt(koe),
  });
}

export const useEndreBudsjett = () =>
  useBudsjettskriving<EndreBudsjett>((ar) => `/budsjett/${String(ar)}`, 'PUT');

export const useOppdaterBudsjettgrunnlag = () =>
  useBudsjettskriving<null>(
    (ar) => `/budsjett/${String(ar)}/grunnlag`,
    'POST',
    () => ({}),
  );

export const useNyBudsjettendring = () =>
  useBudsjettskriving<NyBudsjettendring>((ar) => `/budsjett/${String(ar)}/endringer`, 'POST');

export const useSlettBudsjettendring = () =>
  useBudsjettskriving<string>((ar, id) => `/budsjett/${String(ar)}/endringer/${id}`, 'DELETE');

export const useNyttBudsjetttiltak = () =>
  useBudsjettskriving<NyttBudsjetttiltak>((ar) => `/budsjett/${String(ar)}/tiltak`, 'POST');

export const useEndreBudsjetttiltak = () =>
  useBudsjettskriving<{ id: string } & EndreBudsjetttiltak>(
    (ar, d) => `/budsjett/${String(ar)}/tiltak/${d.id}`,
    'PUT',
    ({ id: _id, ...resten }) => resten,
  );

export const useSlettBudsjetttiltak = () =>
  useBudsjettskriving<string>((ar, id) => `/budsjett/${String(ar)}/tiltak/${id}`, 'DELETE');

export const useSettTiltaksstatus = () =>
  useBudsjettskriving<{ id: string; status: Tiltaksstatus }>(
    (ar, d) => `/budsjett/${String(ar)}/tiltak/${d.id}/status`,
    'PUT',
    ({ status }) => ({ status }),
  );

export const useSettBudsjettfordeling = () =>
  useBudsjettskriving<{ virksomhetId: string } & SettBudsjettfordeling>(
    (ar, d) => `/budsjett/${String(ar)}/fordeling/${d.virksomhetId}`,
    'PUT',
    ({ virksomhetId: _v, ...resten }) => resten,
  );

/** En virksomhets budsjett for budsjettåret, per konto og måned. */
export function useDetaljbudsjett(
  ar: number,
  virksomhetId: string,
): UseQueryResult<DetaljbudsjettDto> {
  return useQuery({
    queryKey: budsjettnokler.detalj(ar, virksomhetId),
    queryFn: () =>
      apiHent(`/budsjett/${String(ar)}/virksomheter/${virksomhetId}`, detaljbudsjettSchema),
  });
}

const kontosti = (ar: number, d: { virksomhetId: string; underkontoId: string }) =>
  `/budsjett/${String(ar)}/virksomheter/${d.virksomhetId}/kontoer/${d.underkontoId}`;

export const useSettDetaljrad = () =>
  useBudsjettskriving<{ virksomhetId: string; underkontoId: string } & SettDetaljrad>(
    kontosti,
    'PUT',
    ({ maneder, versjon }) => ({ maneder, versjon }),
  );

export const useSlettDetaljrad = () =>
  useBudsjettskriving<{ virksomhetId: string; underkontoId: string }>(kontosti, 'DELETE');

export const useDetaljFraFjoraaret = () =>
  useBudsjettskriving<string>(
    (ar, virksomhetId) => `/budsjett/${String(ar)}/virksomheter/${virksomhetId}/fra-fjoraaret`,
    'POST',
    () => ({}),
  );

/** Kommunedirektørens forslag, partienes forslag og vedtaket, regnet ut. */
export function useBudsjettforslagene(
  ar: number,
  aktiv: boolean,
): UseQueryResult<BudsjettforslageneDto> {
  return useQuery({
    queryKey: budsjettnokler.forslag(ar),
    queryFn: () => apiHent(`/budsjett/${String(ar)}/forslag`, budsjettforslageneSchema),
    enabled: aktiv,
  });
}

export function useOpprettBudsjettforslag(): UseMutationResult<
  OpprettetBudsjettforslag,
  unknown,
  { ar: number; data: NyttBudsjettforslag }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ ar, data }) =>
      apiHent(`/budsjett/${String(ar)}/forslag`, opprettetBudsjettforslagSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSettled: () => hentBudsjettPaNytt(koe),
  });
}

const forslagssti = (ar: number, id: string) => `/budsjett/${String(ar)}/forslag/${id}`;

export const useEndreBudsjettforslag = () =>
  useBudsjettskriving<{ id: string } & EndreBudsjettforslag>(
    (ar, d) => forslagssti(ar, d.id),
    'PUT',
    ({ id: _id, ...resten }) => resten,
  );

export const useSlettBudsjettforslag = () =>
  useBudsjettskriving<string>((ar, id) => forslagssti(ar, id), 'DELETE');

export const useSettForslagsvalg = () =>
  useBudsjettskriving<{ id: string; tiltakId: string; med: boolean | null }>(
    (ar, d) => `${forslagssti(ar, d.id)}/tiltak/${d.tiltakId}`,
    'PUT',
    ({ med }) => ({ med }),
  );

export const useSettForslagsprosjekt = () =>
  useBudsjettskriving<{ id: string; prosjektId: string; med: boolean | null }>(
    (ar, d) => `${forslagssti(ar, d.id)}/prosjekter/${d.prosjektId}`,
    'PUT',
    ({ med }) => ({ med }),
  );

export const useNyForslagslinje = () =>
  useBudsjettskriving<{ id: string } & NyForslagslinje>(
    (ar, d) => `${forslagssti(ar, d.id)}/linjer`,
    'POST',
    ({ id: _id, ...resten }) => resten,
  );

export const useSlettForslagslinje = () =>
  useBudsjettskriving<{ id: string; linjeId: string }>(
    (ar, d) => `${forslagssti(ar, d.id)}/linjer/${d.linjeId}`,
    'DELETE',
  );

export const useRegistrerVedtak = () =>
  useBudsjettskriving<RegistrerVedtak>((ar) => `/budsjett/${String(ar)}/vedtak`, 'POST');

/** Om det vedtatte budsjettet kan tas i bruk, og det som ikke går opp. */
export function useBudsjettibruk(ar: number, aktiv: boolean): UseQueryResult<BudsjettibrukDto> {
  return useQuery({
    queryKey: budsjettnokler.iBruk(ar),
    queryFn: () => apiHent(`/budsjett/${String(ar)}/i-bruk`, budsjettibrukSchema),
    enabled: aktiv,
  });
}

export const useTaIBruk = () =>
  useBudsjettskriving<TaIBruk>((ar) => `/budsjett/${String(ar)}/i-bruk`, 'POST');

/** Investeringsprosjektene, finansieringen og driftskonsekvensene. */
export function useInvesteringsbudsjett(ar: number): UseQueryResult<InvesteringsbudsjettDto> {
  return useQuery({
    queryKey: budsjettnokler.investering(ar),
    queryFn: () => apiHent(`/budsjett/${String(ar)}/investering`, investeringsbudsjettSchema),
  });
}

export const useNyttInvesteringsprosjekt = () =>
  useBudsjettskriving<NyttInvesteringsprosjekt>(
    (ar) => `/budsjett/${String(ar)}/investering`,
    'POST',
  );

export const useEndreInvesteringsprosjekt = () =>
  useBudsjettskriving<{ id: string } & EndreInvesteringsprosjekt>(
    (ar, d) => `/budsjett/${String(ar)}/investering/${d.id}`,
    'PUT',
    ({ id: _id, ...resten }) => resten,
  );

export const useSlettInvesteringsprosjekt = () =>
  useBudsjettskriving<string>((ar, id) => `/budsjett/${String(ar)}/investering/${id}`, 'DELETE');

export const useSettInvesteringsstatus = () =>
  useBudsjettskriving<{ id: string; status: Tiltaksstatus }>(
    (ar, d) => `/budsjett/${String(ar)}/investering/${d.id}/status`,
    'PUT',
    ({ status }) => ({ status }),
  );

export const useSettLanerente = () =>
  useBudsjettskriving<{ lanerente: string }>(
    (ar) => `/budsjett/${String(ar)}/investering/rente`,
    'PUT',
  );

/** Revisjonene av det vedtatte budsjettet. */
export function useBudsjettrevisjoner(ar: number): UseQueryResult<BudsjettrevisjonerDto> {
  return useQuery({
    queryKey: budsjettnokler.revisjoner(ar),
    queryFn: () => apiHent(`/budsjett/${String(ar)}/revisjoner`, budsjettrevisjonerSchema),
  });
}

const revisjonssti = (ar: number, id: string) => `/budsjett/${String(ar)}/revisjoner/${id}`;

export const useNyBudsjettrevisjon = () =>
  useBudsjettskriving<{ navn: string }>((ar) => `/budsjett/${String(ar)}/revisjoner`, 'POST');

export const useSlettBudsjettrevisjon = () =>
  useBudsjettskriving<string>((ar, id) => revisjonssti(ar, id), 'DELETE');

export const useNyRevisjonslinje = () =>
  useBudsjettskriving<{ id: string } & NyRevisjonslinje>(
    (ar, d) => `${revisjonssti(ar, d.id)}/linjer`,
    'POST',
    ({ id: _id, ...resten }) => resten,
  );

export const useSlettRevisjonslinje = () =>
  useBudsjettskriving<{ id: string; linjeId: string }>(
    (ar, d) => `${revisjonssti(ar, d.id)}/linjer/${d.linjeId}`,
    'DELETE',
  );

export const useSettRevisjonsrapport = () =>
  useBudsjettskriving<{ id: string; rapportId: string | null }>(
    (ar, d) => `${revisjonssti(ar, d.id)}/rapport`,
    'PUT',
    ({ rapportId }) => ({ rapportId }),
  );

export const useRegistrerRevisjonsvedtak = () =>
  useBudsjettskriving<{ id: string } & RegistrerRevisjonsvedtak>(
    (ar, d) => `${revisjonssti(ar, d.id)}/vedtak`,
    'POST',
    ({ id: _id, ...resten }) => resten,
  );

// --- Tabeller, figurer og bilder --------------------------------------------------

export function useNyttElement(): UseMutationResult<
  RapportelementDto,
  unknown,
  {
    rapportId: string;
    kapittelId: string;
    omradeId: string | null;
    feltId: string;
    element: Elementinnhold;
  }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/elementer`, rapportelementSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => hentRapporterPaNytt(koe),
  });
}

export function useEndreElement(): UseMutationResult<
  RapportelementDto,
  unknown,
  { rapportId: string; elementId: string; versjon: number; element: Elementinnhold }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, elementId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/elementer/${elementId}`, rapportelementSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

export function useFlyttElement(): UseMutationResult<
  void,
  unknown,
  { rapportId: string; elementId: string; retning: 'opp' | 'ned' }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, elementId, retning }) => {
      await apiHent(
        `/rapportering/rapporter/${rapportId}/elementer/${elementId}/flytt`,
        z.unknown(),
        { method: 'POST', body: JSON.stringify({ retning }) },
      );
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

export function useSlettElement(): UseMutationResult<
  void,
  unknown,
  { rapportId: string; elementId: string }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ rapportId, elementId }) => {
      await apiHent(`/rapportering/rapporter/${rapportId}/elementer/${elementId}`, z.unknown(), {
        method: 'DELETE',
      });
    },
    onSettled: () => hentRapporterPaNytt(koe),
  });
}

/** Laster opp et bilde. Id-en brukes så i et bildeelement. */
export function useLastOppBilde(): UseMutationResult<
  { bildeId: string },
  unknown,
  { rapportId: string; fil: File }
> {
  return useMutation({
    mutationFn: ({ rapportId, fil }) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      return apiHent(`/rapportering/rapporter/${rapportId}/bilder`, opplastetBildeSchema, {
        method: 'POST',
        body: skjema,
      });
    },
  });
}

/**
 * Et bilde i rapporten, som en objekt-URL. Et bilde endres aldri — et nytt
 * får en ny id — så det hentes én gang.
 */
export function useBilde(bildeId: string): UseQueryResult<Blob> {
  return useQuery({
    queryKey: ['rapportering', 'bilde', bildeId],
    queryFn: () => apiBlob(`/rapportering/bilder/${bildeId}`),
    staleTime: Infinity,
  });
}

// --- Politisk behandling -------------------------------------------------------

/** Etter en endring i behandlingen: listen, utsendelsen og oppgavene hentes på nytt. */
const hentBehandlingPaNytt = (koe: ReturnType<typeof useQueryClient>) =>
  Promise.all([
    koe.invalidateQueries({ queryKey: nokler.behandling }),
    koe.invalidateQueries({ queryKey: nokler.rapportoppgaver }),
  ]);

/** Utsendelsene kalleren ser, for én rapport eller alle. */
export function useUtsendelser(
  rapportId: string | null = null,
  aktiv = true,
): UseQueryResult<UtsendelserDto> {
  return useQuery({
    enabled: aktiv,
    queryKey: nokler.utsendelser(rapportId),
    queryFn: () =>
      apiHent(
        `/rapportering/behandling${rapportId === null ? '' : `?rapportId=${rapportId}`}`,
        utsendelserSchema,
      ),
  });
}

/** Én utsendelse: rapporten slik den ble sendt, og kommentarene. */
export function useUtsendelse(id: string | null): UseQueryResult<UtsendelseDetaljDto> {
  return useQuery({
    queryKey: nokler.utsendelse(id ?? ''),
    queryFn: () => apiHent(`/rapportering/behandling/${id ?? ''}`, utsendelseDetaljSchema),
    enabled: id !== null,
  });
}

export function useSendTilBehandling(): UseMutationResult<
  UtsendelseDto,
  unknown,
  { rapportId: string } & SendTilBehandling
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ rapportId, ...data }) =>
      apiHent(`/rapportering/rapporter/${rapportId}/behandling`, utsendelseSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => hentBehandlingPaNytt(koe),
  });
}

/** En kommentar fra en folkevalgt, eller — med `svarPa` — et svar i en tråd. */
export function useKommenter(): UseMutationResult<
  void,
  unknown,
  { utsendelseId: string; tekst: string } & (
    { anker: AnkerDto; svarPa?: undefined } | { svarPa: string; anker?: undefined }
  )
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ utsendelseId, tekst, anker, svarPa }) => {
      const base = `/rapportering/behandling/${utsendelseId}/kommentarer`;
      await apiHent(svarPa === undefined ? base : `${base}/${svarPa}/svar`, z.unknown(), {
        method: 'POST',
        body: JSON.stringify(svarPa === undefined ? { anker, tekst } : { tekst }),
      });
    },
    onSuccess: () => hentBehandlingPaNytt(koe),
  });
}

export function useRegistrerBehandling(): UseMutationResult<
  void,
  unknown,
  { utsendelseId: string } & RegistrerBehandling
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ utsendelseId, ...data }) => {
      await apiHent(`/rapportering/behandling/${utsendelseId}/behandlet`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => hentBehandlingPaNytt(koe),
  });
}

/** En fastsatt versjon. Endres aldri, så den trenger ikke hentes på nytt. */
export function useRapportversjon(
  rapportId: string,
  versjon: number | null,
): UseQueryResult<RapportversjonDto> {
  return useQuery({
    queryKey: nokler.rapportversjon(rapportId, versjon ?? 0),
    queryFn: () =>
      apiHent(
        `/rapportering/rapporter/${rapportId}/versjoner/${String(versjon)}`,
        rapportversjonSchema,
      ),
    enabled: versjon !== null,
    staleTime: Infinity,
  });
}

/**
 * Hva som venter på kalleren: leveringer å godkjenne, levere eller rette.
 *
 * `aktiv` er om prognosemodulen er på. Er den av, finnes det ingen oppgaver,
 * og endepunktet ville svart 403.
 */
export function useOppgaver(aktiv: boolean): UseQueryResult<OppgaverDto> {
  return useQuery({
    queryKey: nokler.oppgaver,
    queryFn: () => apiHent('/oppgaver', oppgaverSchema),
    enabled: aktiv,
  });
}

// --- Uvanlige posteringer ------------------------------------------------------

export function usePosteringsvarsler(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<PosteringsvarslerDto> {
  return useQuery({
    queryKey: nokler.posteringsvarsler(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/prognose/varsler?ar=${ar}`,
        posteringsvarslerSchema,
      ),
    enabled: virksomhetId !== undefined,
    staleTime: 60 * 1000,
  });
}

export function useKvitterVarsel(): UseMutationResult<
  PosteringsvarslerDto,
  unknown,
  { virksomhetId: string } & KvitterVarsel
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ virksomhetId, ...data }) =>
      apiHent(
        `/virksomheter/${virksomhetId}/prognose/varsler/kvitteringer`,
        posteringsvarslerSchema,
        {
          method: 'POST',
          body: JSON.stringify(data),
        },
      ),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.posteringsvarsler(svar.virksomhetId, svar.ar), svar);
      void koe.invalidateQueries({ queryKey: nokler.varseloppgaver });
    },
  });
}

/**
 * Hvor godt leveringene traff utfallet for et avsluttet år: for én
 * virksomhet, eller for hver virksomhet i et område.
 */
export function useTreffsikkerhet(
  omfang: { readonly type: 'virksomhet' | 'omrade'; readonly id: string },
  ar: number,
): UseQueryResult<TreffsikkerhetDto> {
  const sti = omfang.type === 'virksomhet' ? 'virksomheter' : 'kommunalomrader';
  return useQuery({
    queryKey: nokler.treffsikkerhet(omfang.type, omfang.id, ar),
    queryFn: () =>
      apiHent(
        `/${sti}/${omfang.id}/prognose/treffsikkerhet?ar=${String(ar)}`,
        treffsikkerhetSchema,
      ),
    staleTime: 5 * 60 * 1000,
  });
}

// --- Møter og grupper -----------------------------------------------------------

export function useGruppeoversikt(): UseQueryResult<GruppeoversiktDto> {
  return useQuery({
    queryKey: nokler.grupper,
    queryFn: () => apiHent('/grupper', gruppeoversiktSchema),
  });
}

export function useGruppe(gruppeId: string | null): UseQueryResult<GruppeDto> {
  return useQuery({
    queryKey: nokler.gruppe(gruppeId ?? ''),
    queryFn: () => apiHent(`/grupper/${gruppeId ?? ''}`, gruppeSchema),
    enabled: gruppeId !== null,
  });
}

export function useGruppekandidater(aktiv: boolean): UseQueryResult<Gruppekandidater> {
  return useQuery({
    queryKey: nokler.gruppekandidater,
    queryFn: () => apiHent('/grupper/kandidater', gruppekandidaterSchema),
    enabled: aktiv,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMote(gruppeId: string | null, moteId: string | null): UseQueryResult<MoteDto> {
  return useQuery({
    queryKey: nokler.mote(gruppeId ?? '', moteId ?? ''),
    queryFn: () => apiHent(`/grupper/${gruppeId ?? ''}/moter/${moteId ?? ''}`, moteSchema),
    enabled: gruppeId !== null && moteId !== null,
  });
}

export function useAksjonsoppgaver(aktiv: boolean): UseQueryResult<AksjonsoppgaverDto> {
  return useQuery({
    queryKey: nokler.aksjonsoppgaver,
    queryFn: () => apiHent('/oppgaver/aksjonspunkter', aksjonsoppgaverSchema),
    enabled: aktiv,
  });
}

/** Kontrollene i vedlikeholdsappen som forfaller. Se `domain/kontroller.ts`. */
export function useKontrolloppgaver(aktiv: boolean): UseQueryResult<KontrolloppgaverDto> {
  return useQuery({
    queryKey: nokler.kontrolloppgaver,
    queryFn: () => apiHent('/vedlikehold/oppgaver', kontrolloppgaverSchema),
    enabled: aktiv,
  });
}

/** Fremdriften i en prosjektgruppe. Se `domain/prosjektfremdrift.ts`. */
export function useProsjektfremdrift(
  gruppeId: string,
  aktiv: boolean,
): UseQueryResult<ProsjektfremdriftDto> {
  return useQuery({
    queryKey: nokler.fremdrift(gruppeId),
    queryFn: () => apiHent(`/grupper/${gruppeId}/fremdrift`, prosjektfremdriftSchema),
    enabled: aktiv,
  });
}

export function useNyMilepael(gruppeId: string): UseMutationResult<void, unknown, LagreMilepael> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      await apiHent(`/grupper/${gruppeId}/milepaeler`, z.unknown(), {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.fremdrift(gruppeId) });
    },
  });
}

export function useEndreMilepael(
  gruppeId: string,
): UseMutationResult<void, unknown, { milepaelId: string } & LagreMilepael> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ milepaelId, ...data }) => {
      await apiHent(`/grupper/${gruppeId}/milepaeler/${milepaelId}`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.fremdrift(gruppeId) });
    },
  });
}

export function useSlettMilepael(gruppeId: string): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (milepaelId) => {
      await apiHent(`/grupper/${gruppeId}/milepaeler/${milepaelId}`, z.unknown(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.fremdrift(gruppeId) });
    },
  });
}

export function useSettKoblinger(
  gruppeId: string,
): UseMutationResult<void, unknown, SettKoblinger> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      await apiHent(`/grupper/${gruppeId}/koblinger`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.fremdrift(gruppeId) });
    },
  });
}

/** Alt om gruppene henger sammen: oversikten, gruppen, møtene og oppgavene. */
function nullstillGrupper(koe: ReturnType<typeof useQueryClient>): void {
  void koe.invalidateQueries({ queryKey: nokler.grupper });
  void koe.invalidateQueries({ queryKey: nokler.aksjonsoppgaver });
}

export function useOpprettGruppe(): UseMutationResult<{ id: string }, unknown, NyGruppe> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent('/grupper', z.object({ id: z.string() }), {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useEndreGruppe(gruppeId: string): UseMutationResult<void, unknown, EndreGruppe> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      await apiHent(`/grupper/${gruppeId}`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useArkiverGruppe(gruppeId: string): UseMutationResult<void, unknown, void> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await apiHent(`/grupper/${gruppeId}`, z.unknown(), { method: 'DELETE' });
    },
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useSettMedlemmer(
  gruppeId: string,
): UseMutationResult<void, unknown, SettMedlemmer> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      await apiHent(`/grupper/${gruppeId}/medlemmer`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useNyttMote(
  gruppeId: string,
): UseMutationResult<{ id: string }, unknown, NyttMote> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent(`/grupper/${gruppeId}/moter`, z.object({ id: z.string() }), {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useLagreMote(
  gruppeId: string,
  moteId: string,
): UseMutationResult<MoteDto, unknown, LagreMote> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent(`/grupper/${gruppeId}/moter/${moteId}`, moteSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.mote(gruppeId, moteId), svar);
      nullstillGrupper(koe);
    },
  });
}

export function useSlettMote(gruppeId: string): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (moteId) => {
      await apiHent(`/grupper/${gruppeId}/moter/${moteId}`, z.unknown(), { method: 'DELETE' });
    },
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

export function useNyttAksjonspunkt(
  gruppeId: string,
  moteId: string,
): UseMutationResult<MoteDto, unknown, NyttAksjonspunkt> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent(`/grupper/${gruppeId}/moter/${moteId}/aksjonspunkter`, moteSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.mote(gruppeId, moteId), svar);
      nullstillGrupper(koe);
    },
  });
}

export function useEndreAksjonspunkt(
  gruppeId: string,
): UseMutationResult<AksjonspunktDto, unknown, { punktId: string } & EndreAksjonspunkt> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: ({ punktId, ...data }) =>
      apiHent(`/grupper/${gruppeId}/aksjonspunkter/${punktId}`, aksjonspunktSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      nullstillGrupper(koe);
    },
  });
}

/** Virksomhetene der kalleren har uvanlige posteringer å se på. */
export function useVarseloppgaver(aktiv: boolean): UseQueryResult<VarseloppgaverDto> {
  return useQuery({
    queryKey: nokler.varseloppgaver,
    queryFn: () => apiHent('/oppgaver/posteringer', varseloppgaverSchema),
    enabled: aktiv,
  });
}

/** Hvor ofte, og innen når, kommunen leverer prognosen. For administrasjonen. */
export function useLeveringsoppsett(): UseQueryResult<Leveringsoppsett> {
  return useQuery({
    queryKey: nokler.leveringsoppsett,
    queryFn: () => apiHent('/administrasjon/leveringsoppsett', leveringsoppsettSchema),
  });
}

export function useSettLeveringsoppsett(): UseMutationResult<
  Leveringsoppsett,
  unknown,
  Leveringsoppsett
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (oppsett) =>
      apiHent('/administrasjon/leveringsoppsett', leveringsoppsettSchema, {
        method: 'PUT',
        body: JSON.stringify(oppsett),
      }),
    onSuccess: (svar) => {
      koe.setQueryData(nokler.leveringsoppsett, svar);
      // Perioden følger rytmen, og hvem som er forsinket følger fristen.
      void koe.invalidateQueries({ queryKey: nokler.alleLeveringer });
    },
  });
}

/**
 * Endringsloggen for året, nyeste først.
 *
 * Hentes på nytt etter hver lagring (se `useLagrePrognose`), og ellers når
 * siden åpnes: en kollega kan ha lagret i mellomtiden, og det er nettopp det
 * loggen skal vise.
 */
export function usePrognoseendringer(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<PrognoseendringerDto> {
  return useQuery({
    queryKey: nokler.prognoseendringer(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/prognose/endringer?ar=${String(ar)}`,
        prognoseendringerSchema,
      ),
    enabled: virksomhetId !== undefined,
    refetchOnMount: 'always',
  });
}

export function useLagrePrognose(
  virksomhetId: string | undefined,
): UseMutationResult<PrognoseVisning, unknown, LagrePrognose> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: LagrePrognose) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/prognose`, prognoseVisningSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: (svar) => {
      // The server returns the recomputed state, so it becomes the new baseline
      // directly — no refetch, and no window where the screen shows figures the
      // server has not confirmed.
      koe.setQueryData(nokler.prognose(virksomhetId ?? '', svar.ar), svar);
      // The save wrote to the change log, so the log on screen is behind.
      void koe.invalidateQueries({
        queryKey: nokler.prognoseendringer(virksomhetId ?? '', svar.ar),
      });
      // Finansiell oversikt reads the same forecast lines, so its cache is now
      // stale by definition.
      void koe.invalidateQueries({ queryKey: ['finansiell-oversikt'] });
    },
  });
}

export interface AnalyserImportInndata {
  readonly fil: File;
  readonly ar: number;
  readonly filEnhet: 'kr' | 'kr_1000';
  readonly budsjettkilde: 'budsjett' | 'opprinnelig';
}

export function useInnkjop(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<InnkjopsoversiktDto> {
  return useQuery({
    queryKey: nokler.innkjop(virksomhetId ?? '', ar),
    enabled: virksomhetId !== undefined,
    queryFn: () =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/innkjop?ar=${ar}`, innkjopsoversiktSchema),
  });
}

export interface AnalyserInnkjopInndata {
  readonly fil: File;
  readonly ar: number;
  readonly filEnhet: 'kr' | 'kr_1000';
}

export function useAnalyserInnkjop(
  virksomhetId: string | undefined,
): UseMutationResult<InnkjopsanalyseDto, unknown, AnalyserInnkjopInndata> {
  return useMutation({
    mutationFn: ({ fil, ar, filEnhet }: AnalyserInnkjopInndata) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      skjema.append('ar', String(ar));
      skjema.append('filEnhet', filEnhet);
      return apiHent(
        `/virksomheter/${virksomhetId ?? ''}/innkjop/analyser`,
        innkjopsanalyseSchema,
        { method: 'POST', body: skjema },
      );
    },
  });
}

export function useImporterInnkjop(
  virksomhetId: string | undefined,
): UseMutationResult<InnkjopsresultatDto, unknown, ImporterInnkjop> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: ImporterInnkjop) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/innkjop`, innkjopsresultatSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      // Innkjøpsimporten rører verken regnskap eller prognose — den legger
      // dimensjoner på kroner som allerede ligger der. Bare innkjøpsvisningen
      // er utdatert.
      void koe.invalidateQueries({ queryKey: ['innkjop', virksomhetId ?? ''] });
    },
  });
}

export function useAnalyserImport(
  virksomhetId: string | undefined,
): UseMutationResult<ImportanalyseDto, unknown, AnalyserImportInndata> {
  return useMutation({
    mutationFn: ({ fil, ar, filEnhet, budsjettkilde }: AnalyserImportInndata) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      skjema.append('ar', String(ar));
      skjema.append('filEnhet', filEnhet);
      skjema.append('budsjettkilde', budsjettkilde);
      return apiHent(`/virksomheter/${virksomhetId ?? ''}/import/analyser`, importAnalyseSchema, {
        method: 'POST',
        body: skjema,
      });
    },
  });
}

export function useUtforImport(
  virksomhetId: string | undefined,
): UseMutationResult<ImportresultatDto, unknown, UtforImport> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: UtforImport) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/import`, importresultatSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      // An import writes booked actuals, so every view derived from them is stale
      // — including the kontoplan, which may have gained an account.
      void koe.invalidateQueries({ queryKey: ['finansiell-oversikt'] });
      void koe.invalidateQueries({ queryKey: ['prognose'] });
      // Budsjettet kan ha endret seg òg, og oversikten leser det.
      void koe.invalidateQueries({ queryKey: nokler.kontoplan });
    },
  });
}

// --- KPI og tiltak (§4.4) ---------------------------------------------------

export function useKpi(
  virksomhetId: string | undefined,
  ar: number,
  periode: KpiPeriode,
  maned: number | null,
): UseQueryResult<KpiVisning> {
  const sporring = new URLSearchParams({ ar: String(ar), periode });
  if (maned !== null) sporring.set('maned', String(maned));
  return useQuery({
    queryKey: nokler.kpi(virksomhetId ?? '', ar, periode, maned),
    queryFn: () =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/kpi?${sporring.toString()}`, kpiVisningSchema),
    enabled: virksomhetId !== undefined,
    // Computed cards are derived from the forecast on every read, so an import
    // or a saved forecast changes them without anything here being touched.
    staleTime: 30 * 1000,
    refetchOnMount: 'always',
  });
}

/** Invalidates every KPI query for a virksomhet, whichever period is cached. */
function nullstillKpi(koe: ReturnType<typeof useQueryClient>, virksomhetId: string): void {
  void koe.invalidateQueries({ queryKey: ['kpi', virksomhetId] });
}

export function useLagreKpi(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, LagreKpi> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data: LagreKpi) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/kpi`, z.void(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillKpi(koe, virksomhetId ?? '');
    },
  });
}

export interface RegistrerMaaling extends LagreMaaling {
  readonly kpiId: string;
}

export function useRegistrerMaaling(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, RegistrerMaaling> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ kpiId, ...data }: RegistrerMaaling) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/kpi/${kpiId}/maalinger`, z.void(), {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillKpi(koe, virksomhetId ?? '');
    },
  });
}

export function useFjernKpi(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (kpiId: string) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/kpi/${kpiId}`, z.void(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      nullstillKpi(koe, virksomhetId ?? '');
    },
  });
}

export function useTiltak(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<TiltakVisning> {
  return useQuery({
    queryKey: nokler.tiltak(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/tiltak?ar=${ar}`, tiltakVisningSchema),
    enabled: virksomhetId !== undefined,
    staleTime: 30 * 1000,
  });
}

export interface LagreTiltakInndata {
  readonly tiltakId: string | null;
  readonly data: LagreTiltak;
}

export function useLagreTiltak(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, LagreTiltakInndata> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ tiltakId, data }: LagreTiltakInndata) => {
      const sti = `/virksomheter/${virksomhetId ?? ''}/tiltak${tiltakId === null ? '' : `/${tiltakId}`}`;
      await apiHent(sti, z.unknown(), {
        method: tiltakId === null ? 'POST' : 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['tiltak', virksomhetId ?? ''] });
      // A measure carries a KPI link, and every card shows how many it has.
      nullstillKpi(koe, virksomhetId ?? '');
    },
  });
}

export function useSlettTiltak(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (tiltakId: string) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/tiltak/${tiltakId}`, z.void(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['tiltak', virksomhetId ?? ''] });
      nullstillKpi(koe, virksomhetId ?? '');
    },
  });
}

// --- Vedtatte kutt ----------------------------------------------------------

export function useVedtatteKutt(ar: number): UseQueryResult<VedtatteKutt> {
  return useQuery({
    queryKey: nokler.vedtatteKutt(ar),
    queryFn: () => apiHent(`/tiltak/vedtatte?ar=${ar}`, vedtatteKuttSchema),
    staleTime: 30 * 1000,
  });
}

/**
 * Et kutt er også et tiltak i virksomhetens liste, og gevinsten er med i
 * tiltaksgapet — alle tre må hentes på nytt.
 */
function nullstillKutt(koe: ReturnType<typeof useQueryClient>): void {
  void koe.invalidateQueries({ queryKey: ['vedtatte-kutt'] });
  void koe.invalidateQueries({ queryKey: ['tiltak'] });
  void koe.invalidateQueries({ queryKey: ['tiltaksdekning'] });
}

/** Tiltaksgapet: prognosert avvik mot det tiltakene ennå ikke har gitt. */
export function useTiltaksdekning(ar: number): UseQueryResult<Tiltaksdekning> {
  return useQuery({
    queryKey: nokler.tiltaksdekning(ar),
    queryFn: () => apiHent(`/tiltak/dekning?ar=${ar}`, tiltaksdekningSchema),
    staleTime: 30 * 1000,
  });
}

export function useMeldGevinst(): UseMutationResult<
  void,
  unknown,
  { readonly tiltakId: string; readonly data: MeldGevinst }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ tiltakId, data }) => {
      await apiHent(`/tiltak/vedtatte/${tiltakId}/gevinst`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillKutt(koe);
    },
  });
}

export function useLagreVedtattKutt(): UseMutationResult<
  void,
  unknown,
  { readonly tiltakId: string | null; readonly data: LagreVedtattKutt }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ tiltakId, data }) => {
      await apiHent(`/tiltak/vedtatte${tiltakId === null ? '' : `/${tiltakId}`}`, z.unknown(), {
        method: tiltakId === null ? 'POST' : 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillKutt(koe);
    },
  });
}

export function useSlettVedtattKutt(): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (tiltakId: string) => {
      await apiHent(`/tiltak/vedtatte/${tiltakId}`, z.void(), { method: 'DELETE' });
    },
    onSuccess: () => {
      nullstillKutt(koe);
    },
  });
}

// --- Administrasjon (§4.6) --------------------------------------------------

export function useAdministrasjon(): UseQueryResult<Administrasjonsoversikt> {
  return useQuery({
    queryKey: nokler.administrasjon,
    queryFn: () => apiHent('/administrasjon', administrasjonsoversiktSchema),
    // Access changes are rare but consequential; a stale list here is a list of
    // who can see the kommune's finances.
    staleTime: 15 * 1000,
    refetchOnMount: 'always',
  });
}

export function useInviterBruker(): UseMutationResult<InvitasjonOpprettet, unknown, InviterBruker> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: InviterBruker) =>
      apiHent('/administrasjon/brukere', invitasjonOpprettetSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export function useOmradeoversikt(
  omradeId: string | undefined,
  ar: number,
): UseQueryResult<Omradeoversikt> {
  return useQuery({
    queryKey: nokler.omradeoversikt(omradeId ?? '', ar),
    queryFn: () =>
      apiHent(`/kommunalomrader/${omradeId ?? ''}/oversikt?ar=${String(ar)}`, omradeoversiktSchema),
    enabled: omradeId !== undefined,
  });
}

export function useOpprettKommunalomrade(): UseMutationResult<
  void,
  unknown,
  OpprettKommunalomrade
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data: OpprettKommunalomrade) => {
      await apiHent('/administrasjon/kommunalomrader', z.void(), {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      // Områdesummen er summen av virksomhetene under. Endres organisasjonen,
      // er den summen ikke lenger den samme.
      void koe.invalidateQueries({ queryKey: nokler.alleOmradeoversikter });
    },
  });
}

export function useOpprettUtvalg(): UseMutationResult<void, unknown, OpprettUtvalg> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      await apiHent('/administrasjon/utvalg', z.void(), {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => koe.invalidateQueries({ queryKey: nokler.administrasjon }),
  });
}

export function useEndreUtvalg(): UseMutationResult<
  void,
  unknown,
  { utvalgId: string; data: EndreUtvalg }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ utvalgId, data }) => {
      await apiHent(`/administrasjon/utvalg/${utvalgId}`, z.void(), {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => koe.invalidateQueries({ queryKey: nokler.administrasjon }),
  });
}

export interface EndreOmradeInndata {
  readonly omradeId: string;
  readonly data: EndreKommunalomrade;
}

export function useEndreKommunalomrade(): UseMutationResult<void, unknown, EndreOmradeInndata> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ omradeId, data }: EndreOmradeInndata) => {
      await apiHent(`/administrasjon/kommunalomrader/${omradeId}`, z.void(), {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      // Områdesummen er summen av virksomhetene under. Endres organisasjonen,
      // er den summen ikke lenger den samme.
      void koe.invalidateQueries({ queryKey: nokler.alleOmradeoversikter });
    },
  });
}

export function useOpprettVirksomhet(): UseMutationResult<void, unknown, OpprettVirksomhet> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data: OpprettVirksomhet) => {
      await apiHent('/administrasjon/virksomheter', z.void(), {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      // Også virksomhetslisten ellers i appen: en ny virksomhet skal dukke opp
      // i velgeren uten at noen laster siden på nytt.
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      void koe.invalidateQueries({ queryKey: nokler.virksomheter });
      // Områdesummen er summen av virksomhetene under. Endres organisasjonen,
      // er den summen ikke lenger den samme.
      void koe.invalidateQueries({ queryKey: nokler.alleOmradeoversikter });
    },
  });
}

export interface EndreVirksomhetInndata {
  readonly virksomhetId: string;
  readonly data: EndreVirksomhet;
}

export function useEndreVirksomhet(): UseMutationResult<void, unknown, EndreVirksomhetInndata> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ virksomhetId, data }: EndreVirksomhetInndata) => {
      await apiHent(`/administrasjon/virksomheter/${virksomhetId}`, z.void(), {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      void koe.invalidateQueries({ queryKey: nokler.virksomheter });
      // Områdesummen er summen av virksomhetene under. Endres organisasjonen,
      // er den summen ikke lenger den samme.
      void koe.invalidateQueries({ queryKey: nokler.alleOmradeoversikter });
    },
  });
}

export function useLeggTilIdentitetsleverandor(): UseMutationResult<
  IdentitetsleverandorDto,
  unknown,
  OpprettIdentitetsleverandor
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: OpprettIdentitetsleverandor) =>
      apiHent('/administrasjon/identitetsleverandorer', identitetsleverandorSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export interface EndreLeverandorInndata {
  readonly leverandorId: string;
  readonly data: EndreIdentitetsleverandor;
}

export function useEndreIdentitetsleverandor(): UseMutationResult<
  void,
  unknown,
  EndreLeverandorInndata
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ leverandorId, data }: EndreLeverandorInndata) => {
      await apiHent(`/administrasjon/identitetsleverandorer/${leverandorId}`, z.void(), {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export function useFjernIdentitetsleverandor(): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (leverandorId: string) => {
      await apiHent(`/administrasjon/identitetsleverandorer/${leverandorId}`, z.void(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export interface EndreBrukerInndata {
  readonly brukerId: string;
  readonly data: EndreBruker;
}

export function useEndreBruker(): UseMutationResult<void, unknown, EndreBrukerInndata> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ brukerId, data }: EndreBrukerInndata) => {
      await apiHent(`/administrasjon/brukere/${brukerId}`, z.void(), {
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      // The caller may have just changed their own role, so what the menu should
      // show is no longer what it shows.
      void koe.invalidateQueries({ queryKey: nokler.meg });
    },
  });
}

export interface SettTilgangerInndata {
  readonly brukerId: string;
  readonly data: SettTilganger;
}

export function useSettTilganger(): UseMutationResult<void, unknown, SettTilgangerInndata> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ brukerId, data }: SettTilgangerInndata) => {
      await apiHent(`/administrasjon/brukere/${brukerId}/tilganger`, z.void(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
      void koe.invalidateQueries({ queryKey: nokler.meg });
      // Lista over virksomheter FILTRERES på tilgang. Uten dette dukker en
      // virksomhet man nettopp ga seg selv tilgang til ikke opp i velgeren før
      // etter fem minutter — som ser ut som om tildelingen ikke virket.
      void koe.invalidateQueries({ queryKey: nokler.virksomheter });
      void koe.invalidateQueries({ queryKey: nokler.alleOmradeoversikter });
    },
  });
}

/** Sender en utløpt eller tilbaketrukket invitasjon på nytt, med ny frist. */
export function useFornyInvitasjon(): UseMutationResult<InvitasjonOpprettet, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (invitasjonId: string) =>
      apiHent(`/administrasjon/invitasjoner/${invitasjonId}/forny`, invitasjonOpprettetSchema, {
        method: 'POST',
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export function useTrekkInvitasjon(): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (invitasjonId: string) => {
      await apiHent(`/administrasjon/invitasjoner/${invitasjonId}`, z.void(), { method: 'DELETE' });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.administrasjon });
    },
  });
}

export function useRevisjonslogg(
  side: number,
  handling: string,
): UseQueryResult<RevisjonsloggSvar> {
  const sporring = new URLSearchParams({ side: String(side), antall: '25' });
  if (handling !== '') sporring.set('handling', handling);
  return useQuery({
    queryKey: nokler.revisjonslogg(side, handling),
    queryFn: () =>
      apiHent(`/administrasjon/revisjonslogg?${sporring.toString()}`, revisjonsloggSvarSchema),
    staleTime: 15 * 1000,
  });
}

/**
 * Lesesporet for lønnsopplysninger (beslutning 10).
 *
 * Ligger under administrasjon og ikke under bemanning, og ikke bak
 * bemanningsflagget: spørsmålet «hvem har sett opplysningene om meg» skal kunne
 * besvares også etter at modulen er slått av.
 */
export function useLonnslesing(
  side: number,
  ansattId: string | null,
): UseQueryResult<LonnslesingSvar> {
  const sporring = new URLSearchParams({ side: String(side), antall: '25' });
  if (ansattId !== null) sporring.set('ansattId', ansattId);
  return useQuery({
    queryKey: nokler.lonnslesing(side, ansattId ?? ''),
    queryFn: () =>
      apiHent(`/administrasjon/lonnslesing?${sporring.toString()}`, lonnslesingSvarSchema),
    staleTime: 15 * 1000,
  });
}

/**
 * Bemanningen for ett år (§4.5).
 *
 * Vakans og fraværsprosent regnes ut på serveren ved hver lesing, så en import
 * endrer dem uten at noe her må røres.
 */
export function useBemanning(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<Bemanningsoversikt> {
  return useQuery({
    queryKey: nokler.bemanning(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning?ar=${String(ar)}`,
        bemanningsoversiktSchema,
      ),
    enabled: virksomhetId !== undefined,
    staleTime: 30 * 1000,
  });
}

interface AnalyserBemanningInndata {
  readonly fil: File;
  readonly ar: number;
}

/** Leser en bemanningsfil og viser hva den ville gjort. Skriver ingenting. */
export function useAnalyserBemanning(
  virksomhetId: string | undefined,
): UseMutationResult<Bemanningsanalyse, unknown, AnalyserBemanningInndata> {
  return useMutation({
    mutationFn: ({ fil, ar }: AnalyserBemanningInndata) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      skjema.append('ar', String(ar));
      return apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/analyser`,
        bemanningsanalyseSchema,
        {
          method: 'POST',
          body: skjema,
        },
      );
    },
  });
}

export function useUtforBemanningsimport(
  virksomhetId: string | undefined,
): UseMutationResult<BemanningsresultatDto, unknown, UtforBemanningsimport> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: UtforBemanningsimport) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/bemanning/import`, bemanningsresultatSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      // Bemanningstallene endrer også KPI-ene som beregnes fra dem, så begge
      // køene må tømmes — ellers viser et sykefraværskort gårsdagens tall.
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
      void koe.invalidateQueries({ queryKey: ['kpi', virksomhetId] });
    },
  });
}

/**
 * Koblingen mellom lønnsregisteret og prognosen (§4.5).
 *
 * Å endre den endrer hva PROGNOSEN viser for hele virksomheten, så begge køene
 * tømmes — ellers ville prognoseskjermen vist gårsdagens tall til noen lastet
 * den på nytt.
 */
export function usePrognosekobling(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<LonnsprognosekoblingDto> {
  return useQuery({
    queryKey: nokler.prognosekobling(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/prognosekobling?ar=${String(ar)}`,
        lonnsprognosekoblingSchema,
      ),
    enabled: virksomhetId !== undefined,
  });
}

export function useSettPrognosekobling(
  virksomhetId: string | undefined,
): UseMutationResult<LonnsprognosekoblingDto, unknown, SettLonnsprognosekobling> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: SettLonnsprognosekobling) =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/prognosekobling`,
        lonnsprognosekoblingSchema,
        { method: 'PUT', body: JSON.stringify(data) },
      ),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
      void koe.invalidateQueries({ queryKey: ['prognose', virksomhetId] });
      void koe.invalidateQueries({ queryKey: ['oversikt'] });
    },
  });
}

/**
 * Stillingsoversikten: hvem som er ansatt, og hva det koster (§4.5).
 *
 * Merk at dette oppslaget SKRIVER noe — ett innslag i lesesporet med alle som
 * ble vist. Derfor ingen lang `staleTime`: hver visning skal kunne besvares,
 * og en cache som skjulte oppslaget ville gjort sporet ufullstendig.
 */
export function useStillingsoversikt(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<Stillingsoversikt> {
  return useQuery({
    queryKey: nokler.stillingsoversikt(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/stillinger?ar=${String(ar)}`,
        stillingsoversiktSchema,
      ),
    enabled: virksomhetId !== undefined,
  });
}

/**
 * Stillingsgruppene kommunen fører bemanning på.
 *
 * Delt av alle virksomheter i kommunen, men hentet gjennom en virksomhet fordi
 * tilgangen avgjøres av den. Brukes av hjemmelskjemaet: en hjemmel må høre til
 * en gruppe som finnes, og skjermen skal ikke la noen skrive en kode som ikke
 * gjør det.
 */
export function useStillingsgrupper(
  virksomhetId: string | undefined,
): UseQueryResult<StillingsgruppeDto[]> {
  return useQuery({
    queryKey: ['bemanning', virksomhetId, 'stillingsgrupper'],
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/stillingsgrupper`,
        z.array(stillingsgruppeSchema),
      ),
    enabled: virksomhetId !== undefined,
  });
}

/**
 * Stillingshjemlene — de vedtatte stillingene (beslutning 7).
 *
 * Leses gjennom stillingsoversikten, så skrivingen tømmer den nøkkelen:
 * vakansen utledes av hjemlene, og en ny hjemmel endrer den med en gang.
 */
export function useSettStillingshjemmel(
  virksomhetId: string | undefined,
): UseMutationResult<StillingshjemmelDto, unknown, SettStillingshjemmel> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: SettStillingshjemmel) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler`, stillingshjemmelSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

/**
 * Stillingsforholdene som kunne fylt hjemmelen (beslutning 7).
 *
 * `enabled` på en hjemmel-id framfor alltid: listen viser navn og
 * stillingsprosent på hele stillingsgruppen og føres i lesesporet. Et oppslag
 * som skjedde fordi skjermen ble åpnet, og ikke fordi noen spurte, ville fylt
 * sporet med visninger ingen har gjort.
 */
export function useHjemmelkandidater(
  virksomhetId: string | undefined,
  hjemmelId: string | null,
): UseQueryResult<HjemmelkandidatDto[]> {
  return useQuery({
    queryKey: ['bemanning', virksomhetId, 'hjemmelkandidater', hjemmelId],
    enabled: virksomhetId !== undefined && hjemmelId !== null,
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler/${hjemmelId ?? ''}/kandidater`,
        z.array(hjemmelkandidatSchema),
      ),
  });
}

/** Knytter et stillingsforhold til en hjemmel, eller løser koblingen med null. */
export function useSettHjemmelskobling(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, SettHjemmelskobling> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (data: SettHjemmelskobling) => {
      await apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler/kobling`,
        z.undefined(),
        {
          method: 'PUT',
          body: JSON.stringify(data),
        },
      );
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

/** Leser en hjemmelfil og viser hva en import ville gjort. Skriver ingenting. */
export function useAnalyserHjemler(
  virksomhetId: string | undefined,
): UseMutationResult<Hjemmelanalyse, unknown, File> {
  return useMutation({
    mutationFn: (fil: File) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      return apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler/analyser`,
        hjemmelanalyseSchema,
        { method: 'POST', body: skjema },
      );
    },
  });
}

export function useImporterHjemler(
  virksomhetId: string | undefined,
): UseMutationResult<HjemmelimportresultatDto, unknown, UtforHjemmelimport> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: UtforHjemmelimport) =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler/import`,
        hjemmelimportresultatSchema,
        { method: 'POST', body: JSON.stringify(data) },
      ),
    onSuccess: () => {
      // Budsjetterte årsverk og vakansen utledes av hjemlene, så oversikten er
      // en annen med en gang.
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

export function useSlettStillingshjemmel(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/bemanning/hjemler/${id}`, z.void(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

/**
 * Satsene lønnskosten regnes med (beslutning 4, 6 og 8).
 *
 * Per kommune, men hentet gjennom en virksomhet — det er virksomheten
 * tilgangen avgjøres av. Nøkkelen ligger under `bemanning`, så en endring i
 * satsene tømmer bemanningstallene som regnes av dem.
 */
export function useLonnsgrunnlag(
  virksomhetId: string | undefined,
  ar: number,
): UseQueryResult<Lonnsgrunnlag> {
  return useQuery({
    queryKey: nokler.lonnsgrunnlag(virksomhetId ?? '', ar),
    queryFn: () =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/grunnlag?ar=${String(ar)}`,
        lonnsgrunnlagSchema,
      ),
    enabled: virksomhetId !== undefined,
  });
}

export function useSettLonnsforutsetning(
  virksomhetId: string | undefined,
): UseMutationResult<LonnsforutsetningDto, unknown, SettLonnsforutsetning> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: SettLonnsforutsetning) =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/forutsetning`,
        lonnsforutsetningSchema,
        { method: 'PUT', body: JSON.stringify(data) },
      ),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

export function useSettLonnsoppgjor(
  virksomhetId: string | undefined,
): UseMutationResult<LonnsoppgjorDto, unknown, SettLonnsoppgjor> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: SettLonnsoppgjor) =>
      apiHent(`/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/oppgjor`, lonnsoppgjorSchema, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

export function useSlettLonnsoppgjor(
  virksomhetId: string | undefined,
): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiHent(`/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/oppgjor/${id}`, z.void(), {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
    },
  });
}

interface AnalyserLonnInndata {
  readonly fil: File;
  readonly virkningsdato: string;
}

/**
 * Leser en lønnsfil og viser hva en import ville gjort. Skriver ingenting.
 *
 * `virkningsdato` følger med filen og ikke i den: eksporten er et øyeblikksbilde
 * av hva som gjelder nå, ikke en logg over når noe ble endret. Datoen avgjør
 * hvilken måned en lønnsøkning havner i, og der er en måneds forskyvning synlig
 * i regnskapet.
 */
export function useAnalyserLonn(
  virksomhetId: string | undefined,
): UseMutationResult<Lonnsanalyse, unknown, AnalyserLonnInndata> {
  return useMutation({
    mutationFn: ({ fil, virkningsdato }: AnalyserLonnInndata) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      skjema.append('virkningsdato', virkningsdato);
      return apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/analyser`,
        lonnsanalyseSchema,
        { method: 'POST', body: skjema },
      );
    },
  });
}

export function useUtforLonnsimport(
  virksomhetId: string | undefined,
): UseMutationResult<LonnsimportresultatDto, unknown, UtforLonnsimport> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: UtforLonnsimport) =>
      apiHent(
        `/virksomheter/${virksomhetId ?? ''}/bemanning/lonn/import`,
        lonnsimportresultatSchema,
        { method: 'POST', body: JSON.stringify(data) },
      ),
    onSuccess: () => {
      // Besatte årsverk utledes av stillingsforholdene, så bemanningstallene er
      // andre etter en lønnsimport enn før — og KPI-ene som regnes av dem med.
      void koe.invalidateQueries({ queryKey: ['bemanning', virksomhetId] });
      void koe.invalidateQueries({ queryKey: ['kpi', virksomhetId] });
    },
  });
}

/**
 * Integrasjoner — kommunens egne nøkler til fagsystemene sine.
 *
 * Ingen av kallene her henter en hemmelighet, og det finnes ikke noe endepunkt
 * som kunne gjort det. Skjemaet sender en nøkkel oppover; ingenting sender den
 * ned igjen.
 */
export function useIntegrasjonsoppsett(aktivert: boolean): UseQueryResult<Integrasjonsoppsett> {
  return useQuery({
    queryKey: nokler.integrasjonsoppsett,
    queryFn: () => apiHent('/integrasjoner/oppsett', integrasjonsoppsettSchema),
    enabled: aktivert,
    staleTime: 5 * 60 * 1000,
  });
}

export function useIntegrasjoner(aktivert: boolean): UseQueryResult<Integrasjon[]> {
  return useQuery({
    queryKey: nokler.integrasjoner,
    queryFn: () => apiHent('/integrasjoner', z.array(integrasjonSchema)),
    enabled: aktivert,
  });
}

export function useOpprettIntegrasjon(): UseMutationResult<Integrasjon, unknown, NyIntegrasjon> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: NyIntegrasjon) =>
      apiHent('/integrasjoner', integrasjonSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.integrasjoner });
    },
  });
}

export function useSettIntegrasjonshemmelighet(): UseMutationResult<
  void,
  unknown,
  { id: string; hemmeligheter: Hemmeligheter }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, hemmeligheter }: { id: string; hemmeligheter: Hemmeligheter }) => {
      // Hele legitimasjonen, ikke ett felt. Et delvis bytte ville krevd at
      // serveren dekrypterte det som ligger der for å slå det sammen — altså en
      // ny grunn til å dekryptere, startet av en HTTP-forespørsel.
      await apiHent(`/integrasjoner/${id}/hemmelighet`, z.void(), {
        method: 'PUT',
        body: JSON.stringify({ hemmeligheter }),
      });
    },
    onSuccess: () => {
      // Tømmes fordi `hemmelighetSatt` er det eneste sporet av byttet som
      // vises. Uten dette ser skjermen ut som om ingenting skjedde.
      void koe.invalidateQueries({ queryKey: nokler.integrasjoner });
    },
  });
}

export function useSettIntegrasjonAktiv(): UseMutationResult<
  void,
  unknown,
  { id: string; aktiv: boolean }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, aktiv }: { id: string; aktiv: boolean }) => {
      await apiHent(`/integrasjoner/${id}/aktiv`, z.void(), {
        method: 'PUT',
        body: JSON.stringify({ aktiv }),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.integrasjoner });
    },
  });
}

export function useSlettIntegrasjon(): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiHent(`/integrasjoner/${id}`, z.void(), { method: 'DELETE' });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.integrasjoner });
    },
  });
}

/**
 * Koblingene fra kontostrengen til virksomhetene.
 *
 * Hver endring her flytter penger fra én virksomhet til en annen i hver
 * framtidige henting, så køen tømmes etter hvert skriv — en skjerm som viser
 * gårsdagens kobling er verre enn en som laster på nytt.
 */
export function useDimensjoner(aktivert: boolean): UseQueryResult<Dimensjonskobling[]> {
  return useQuery({
    queryKey: nokler.dimensjoner,
    queryFn: () => apiHent('/dimensjoner', z.array(dimensjonskoblingSchema)),
    enabled: aktivert,
  });
}

export function useOpprettDimensjonskobling(): UseMutationResult<
  Dimensjonskobling,
  unknown,
  NyDimensjonskobling
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data: NyDimensjonskobling) =>
      apiHent('/dimensjoner', dimensjonskoblingSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.dimensjoner });
    },
  });
}

export function useFlyttDimensjonskobling(): UseMutationResult<
  void,
  unknown,
  { id: string; virksomhetId: string }
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, virksomhetId }: { id: string; virksomhetId: string }) => {
      await apiHent(`/dimensjoner/${id}`, z.void(), {
        method: 'PUT',
        body: JSON.stringify({ virksomhetId }),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.dimensjoner });
    },
  });
}

export function useSlettDimensjonskobling(): UseMutationResult<void, unknown, string> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiHent(`/dimensjoner/${id}`, z.void(), { method: 'DELETE' });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.dimensjoner });
    },
  });
}

/** Hvilken felles visning: en virksomhets eller et kommunalområdes. */
export interface Visningsomfang {
  readonly type: 'virksomhet' | 'omrade';
  readonly id: string;
}

const visningsadresse = (o: Visningsomfang): string =>
  o.type === 'virksomhet'
    ? `/virksomheter/${o.id}/finansiell-oversikt/oppsett`
    : `/kommunalomrader/${o.id}/oversikt/oppsett`;

/** Den felles visningen i finansiell oversikt, og om kalleren kan endre den. */
export function useFellesVisning(
  omfang: Visningsomfang | undefined,
): UseQueryResult<FellesVisningDto> {
  return useQuery({
    queryKey: nokler.fellesVisning(omfang?.type ?? '', omfang?.id ?? ''),
    queryFn: () =>
      apiHent(visningsadresse(omfang ?? { type: 'virksomhet', id: '' }), fellesVisningSchema),
    enabled: omfang !== undefined,
  });
}

/**
 * Lagrer den felles visningen.
 *
 * Omfanget følger med hver lagring, ikke kroken. Lagringen kommer et øyeblikk
 * etter endringen (se `FinansiellOversikt`), og har noen byttet virksomhet i
 * mellomtiden, skal oppsettet likevel havne der det ble laget.
 *
 * `vedKonflikt` kalles når noen andre lagret visningen først. Da er ingenting
 * skrevet over, og den nye versjonen hentes.
 */
export function useLagreFellesVisning(
  vedKonflikt?: () => void,
): UseMutationResult<
  FellesVisningDto,
  unknown,
  { omfang: Visningsomfang; oppsett: OversiktsoppsettDto }
> {
  const koe = useQueryClient();
  return useMutation({
    // One at a time, and the version read when the request leaves rather than
    // when the change was made: two quick changes in a row are two saves on
    // top of each other, and must not be taken for someone else's.
    scope: { id: 'felles-visning' },
    mutationFn: ({ omfang, oppsett }) => {
      const naa = koe.getQueryData<FellesVisningDto>(nokler.fellesVisning(omfang.type, omfang.id));
      return apiHent(visningsadresse(omfang), fellesVisningSchema, {
        method: 'PUT',
        body: JSON.stringify({ versjon: naa?.versjon ?? 0, oppsett }),
      });
    },
    onSuccess: (svar, { omfang }) => {
      koe.setQueryData(nokler.fellesVisning(omfang.type, omfang.id), svar);
    },
    // Someone else saved first. Their layout is fetched, so what is shown is
    // what is stored; this one is not sent again on top of it.
    onError: (feil, { omfang }) => {
      if (erVersjonskonflikt(feil)) {
        void koe.invalidateQueries({ queryKey: nokler.fellesVisning(omfang.type, omfang.id) });
        vedKonflikt?.();
      }
    },
  });
}

// --- Investeringene gjennom året ------------------------------------------------

/** Investeringene for året. Se `domain/investeringsoppfolging.ts`. */
export function useInvesteringer(ar: number): UseQueryResult<InvesteringsoppfolgingDto> {
  return useQuery({
    queryKey: nokler.investeringer(ar),
    queryFn: () => apiHent(`/investeringer?ar=${String(ar)}`, investeringsoppfolgingSchema),
  });
}

/** Prosjektene kalleren skal melde prognose for nå. */
export function useInvesteringsoppgaver(aktiv: boolean): UseQueryResult<InvesteringsoppgaverDto> {
  return useQuery({
    queryKey: nokler.investeringsoppgaver,
    queryFn: () => apiHent('/investeringer/oppgaver', investeringsoppgaverSchema),
    enabled: aktiv,
  });
}

function nullstillInvesteringer(koe: ReturnType<typeof useQueryClient>): void {
  void koe.invalidateQueries({ queryKey: ['investeringer'] });
  void koe.invalidateQueries({ queryKey: nokler.investeringsoppgaver });
}

export function useMeldInvestering(): UseMutationResult<
  void,
  unknown,
  { id: string } & MeldInvesteringsprognose
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      await apiHent(`/investeringer/${id}/prognose`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillInvesteringer(koe);
    },
  });
}

export function useEndreInvestering(): UseMutationResult<
  void,
  unknown,
  { id: string } & EndreInvestering
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      await apiHent(`/investeringer/${id}`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      nullstillInvesteringer(koe);
    },
  });
}

export interface AnalyserInvesteringsimport {
  readonly fil: File;
  readonly ar: number;
  readonly filEnhet: Valutaenhet;
  readonly budsjettkilde: Budsjettkilde;
}

export function useAnalyserInvesteringsimport(): UseMutationResult<
  InvesteringsimportAnalyseDto,
  unknown,
  AnalyserInvesteringsimport
> {
  return useMutation({
    mutationFn: ({ fil, ar, filEnhet, budsjettkilde }) => {
      const skjema = new FormData();
      skjema.append('fil', fil);
      skjema.append('ar', String(ar));
      skjema.append('filEnhet', filEnhet);
      skjema.append('budsjettkilde', budsjettkilde);
      return apiHent('/investeringer/import/analyser', investeringsimportAnalyseSchema, {
        method: 'POST',
        body: skjema,
      });
    },
  });
}

export function useUtforInvesteringsimport(): UseMutationResult<
  InvesteringsimportresultatDto,
  unknown,
  UtforInvesteringsimport
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiHent('/investeringer/import', investeringsimportresultatSchema, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      nullstillInvesteringer(koe);
    },
  });
}

// --- Prosjektporteføljen ------------------------------------------------------------

/** Prosjektene kalleren ser. Se `domain/prosjektportefolje.ts`. */
export function usePortefolje(): UseQueryResult<PortefoljeDto> {
  return useQuery({
    queryKey: nokler.portefolje,
    queryFn: () => apiHent('/prosjekter', portefoljeSchema),
  });
}

export function useLagreProsjektinfo(): UseMutationResult<
  void,
  unknown,
  { gruppeId: string } & LagreProsjektinfo
> {
  const koe = useQueryClient();
  return useMutation({
    mutationFn: async ({ gruppeId, ...data }) => {
      await apiHent(`/prosjekter/${gruppeId}`, z.unknown(), {
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      void koe.invalidateQueries({ queryKey: nokler.portefolje });
    },
  });
}
